import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, throwError } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';

@Injectable()
export class UserService {
    constructor(public http: HttpClient, public authService: AuthService) { 
    }

    changePassword(currentPassword: string, newPassword: string) {
        var body = JSON.stringify({
            currentPassword: currentPassword, newPassword: newPassword
        });

        return from(this.authService.GetDefaultHeaders()).pipe(
            mergeMap(contentHeaders => { console.log(contentHeaders); return this.http.post(ConfigService.AUTH_API_ENDPOINT + 'user/password', body, { headers: contentHeaders }) }),
            catchError(error => {
                console.log(error);
                return throwError(error);
            })
        );
    }
}